import PropTypes from 'prop-types';
import { DEFAULT_PRO_DOMAIN } from '../../utils/constants';

/**
 * @typedef {import('../../types').CurrentSite} CurrentSite
 */

/**
 * Displays the Ghost.io domain section
 * Shows the user's current ghost.io subdomain with an edit button
 * @param {object} props - Component props
 * @param {CurrentSite} props.currentSite - The current site data
 * @param {Function} props.onEditSubdomain - Handler for editing the subdomain
 */
function GhostSubdomainSection({ currentSite, onEditSubdomain }) {
    return (
        <div className="box-domain box-wrap">
            <div className="box">
                <section className="staticfield">
                    <header>
                        <div className="staticfield-label">Ghost.io Domain</div>
                        <button className="staticfield-link" onClick={onEditSubdomain}>
                            Edit
                        </button>
                    </header>
                    <div className="staticfield-value">
                        {currentSite?.subdomain || 'yourdomain'}.
                        {currentSite?.pro_domain || DEFAULT_PRO_DOMAIN}
                    </div>
                </section>
            </div>
        </div>
    );
}

GhostSubdomainSection.propTypes = {
    currentSite: PropTypes.shape({
        subdomain: PropTypes.string,
        pro_domain: PropTypes.string,
    }),
    onEditSubdomain: PropTypes.func.isRequired,
};

export default GhostSubdomainSection;
